export default /* glsl */`
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

// Add additional parameters: uniforms
#include <time_pars_common>
uniform float animInfluence;

void main() {

	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <skinbase_vertex>

	#ifdef USE_ENVMAP

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>

	#endif

	#include <begin_vertex>
	#include <morphtarget_vertex>

	// Wave shape animation
	// Front oriented
	float frequency1 = 0.003;
    float amplitude1 = 2.0;
    float frequency2 = 0.005;
    float amplitude2 = 7.0;
    float speed = 0.5;

    // Oscillate vertices up/down
    transformed.y += (sin(transformed.x * frequency1 + time * speed) * 0.5 + 0.5) * amplitude1 * animInfluence;

    // Oscillate vertices inside/outside
    transformed.z += (sin(transformed.x * frequency2 + time * speed) * 0.5 + 0.5) * amplitude2 * animInfluence;

	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>

	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>

}
`;
